import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../type';

export const siteSelector = (state: RootState) => state.site;

export const isSiteSelector = createSelector(siteSelector, (state) => state);
